export const useIntersectionObserver = (
  intersectionWrapperRef: Ref<HTMLDivElement | undefined>
) => {
  const intersectionHappened = ref(false)
  const observer = ref<IntersectionObserver | undefined>(undefined)

  onMounted(() => {
    if (
      !('IntersectionObserver' in window) ||
      !('IntersectionObserverEntry' in window) ||
      !('intersectionRatio' in window.IntersectionObserverEntry.prototype)
    ) {
      intersectionHappened.value = true
      return
    }

    observer.value = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            intersectionHappened.value = true
          }
        })
      },
      {
        rootMargin: '200px',
        threshold: 0.3,
      }
    )

    // Handle both component refs (with $el) and plain DOM element refs
    const element =
      intersectionWrapperRef.value?.$el || intersectionWrapperRef.value
    if (element) {
      observer.value?.observe(element)
    }
  })

  const stopObserving = () => {
    const element =
      intersectionWrapperRef.value?.$el || intersectionWrapperRef.value
    if (element) {
      observer.value?.unobserve(element)
    }
  }

  onUnmounted(() => {
    stopObserving()
  })

  return { intersectionHappened, stopObserving }
}
